<div class="example_outer_section">
    <div class="example_top_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1>Trinka를 통해 글의 전반적 수준 향상</h1>
                    <p>학술 논문 및 기술 분야 저자를 돕도록 설계된 Trinka는 문법적인 오류를 없애는 것은 물론, 고품질 글로 거듭나도록 교정해 효율적인 소통이 되도록 합니다.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>고급 문법 검사로 오류 교정</h3>
                    <p>학술적 및 기술적 글에서 나타나는 오류는 까다로워 다른 프로그램으로는 포착하기가 힘듭니다. 하지만 Trinka라면 가능합니다!</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>주어-동사 불일치</h4>
                        <p>Therefore, these results suggest that the hypersecretion of CRH and endorphin
                            <span>suppress</span>
                            <span class="right_word">suppresses</span> the secretion of LH and FSH from the pituitary gland.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>단어 선택</h4>
                        <p>The statistical analyses were performed <span>with</span> <span class="right_word">using</span> a statistical analysis software (SAS).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>전치사</h4>
                        <p>Recent years have seen an increase <span>of</span> <span class="right_word">in</span> exudation of various organic acids.</p>
                    </div>
                </div>

                <!-- <div class="col-md-12">
                    <div class="example_box_contents">
                        <h4>Subject-verb disagreement</h4>
                        <p><span>Trinka</span> is your personal <span>AI editor</span> for all your academic writing
                            needs. <span>Trinka</span> is your personal <span>AI editor</span> for all your academic
                            writing needs.</p>
                    </div>
                </div> -->

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>형용사 사용</h4>
                        <p>The group receiving the placebo treatment had the <span>most</span> highest improvement in sleep scores.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->

    <div class="exapmle_cards_heading background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>출판 기준에 맞도록 글의 수준 향상</h3>
                    <p>Trinka는 어조, 스타일, 표준 스타일 가이드 준수를 검사하여 학술 독자층이 읽기에 적합한 글이 되도록 합니다.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>간결함</h4>
                        <p>Utilities would continue to <span>have the obligation</span> <span class="right_word">be
                                obliged</span> to serve retail customers.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>단어 선택</h4>
                        <p>The <span>average</span> <span class="right_word">mean</span> age of the study group was 54.2 years (range: 890 years).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>격식체 어조</h4>
                        <p>The assembly <span>abrogated</span> <span class="right_word">arrogated</span> to itself the right to make changes.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>기술적 단어 선택</h4>
                        <p>Substance <span>abuse</span> <span class="right_word">use disorder</span> has been a major public health concern.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>전문 분야별 검사로 정확한 교정</h3>
                    <p>Trinka는 전문 분야별 고유의 표현을 숙지하고 있습니다. 해당 전문 분야에서 주로 사용하는 문체를 함부로 교정하지 않습니다.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>컴퓨터 과학</h4>
                        <p>In our study, 90% of the users expressed the need for a <span>dialogue</span> <span class="right_word">dialog</span> box to alert them to a pending update.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>물리학</h4>
                        <p>By contrast, the <span>effect</span> <span class="right_word">effects</span> of the Mach number and <span class="right_word">heat</span> specific <span>heat</span> ratio contribute little to the aerodynamic performance.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>의학</h4>
                        <p>Our study matched for age, <span>gender</span> <span class="right_word">sex</span>, ethnicity, and BMI, marijuana use was associated with higher abdominal visceral fat.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>경제학</h4>
                        <p>The estimated natural rate, based on the <span>past</span> history of the data, plummets by nearly 2
                            <span>percent</span> <span class="right_word">percentage</span> points.
                        </p>
                        <!-- <p>Studies have shown that organizational culture and <span>organizational</span> environment
                            now meet work-life policies.
                        </p> -->
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


</div>